/**
 * 仪表盘默认配置
 */
export var DEFAULT_GAUGE_CONFIG = {
    style: 'standard',
    startAngle: -7 / 6,
    endAngle: 1 / 6,
    gaugeStyle: {
        tickLineColor: 'rgba(0,0,0,0)',
        pointerColor: '#bfbfbf',
    },
    statistic: {
        position: ['50%', '80%'],
    },
};
//# sourceMappingURL=options.js.map